var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    fill: "#47AAC9",
    fillOpacity: 0.65
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4649 9.50001L13.1676 6.79727C13.2959 6.66922 13.368 6.49547 13.3682 6.31422C13.3684 6.13298 13.2965 5.9591 13.1685 5.83083C13.0404 5.70255 12.8667 5.6304 12.6854 5.63024C12.5042 5.63008 12.3303 5.70193 12.202 5.82997L9.49928 8.53271L6.79654 5.82997C6.66827 5.7017 6.49429 5.62964 6.31289 5.62964C6.13148 5.62964 5.95751 5.7017 5.82924 5.82997C5.70097 5.95824 5.62891 6.13222 5.62891 6.31362C5.62891 6.49502 5.70097 6.669 5.82924 6.79727L8.53198 9.50001L5.82924 12.2027C5.70097 12.331 5.62891 12.505 5.62891 12.6864C5.62891 12.8678 5.70097 13.0418 5.82924 13.17C5.95751 13.2983 6.13148 13.3704 6.31289 13.3704C6.49429 13.3704 6.66827 13.2983 6.79654 13.17L9.49928 10.4673L12.202 13.17C12.3303 13.2983 12.5043 13.3704 12.6857 13.3704C12.8671 13.3704 13.041 13.2983 13.1693 13.17C13.2976 13.0418 13.3696 12.8678 13.3696 12.6864C13.3696 12.505 13.2976 12.331 13.1693 12.2027L10.4649 9.50001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearBadge);
export default __webpack_public_path__ + "static/media/clearBadge.6959ce5a4403ad6e2144ed8da36f4990.svg";
export { ForwardRef as ReactComponent };